module.exports = __webpack_public_path__ + "static/media/prompt-answer.74a84bbc.png";